<script setup lang="ts">
import BwFormIcon from '../../Icon/Form/bw-icon.vue'
import { DropdownMenuItem } from '@/components/ui/dropdown-menu'
import type { Elemental } from '~~/src/types/elemental'

const { elemental } = defineProps<{
  elemental: Elemental
  route: string
}>()

const runtimeConfig = useRuntimeConfig()

const open = () => {
  const formBuilderUrl = runtimeConfig.public.spWebAppUrl
  window.open(`${formBuilderUrl}/forms/${elemental.id}`, '_blank')
}
defineOptions({
  name: 'OpenElementalFormOption',
})
</script>

<template>
  <DropdownMenuItem @click="open">
    <BwFormIcon />
    Open Form View
  </DropdownMenuItem>
</template>
